import { AnyAction, CombinedState, combineReducers } from 'redux'
import accountingApp from '../views/accounting/reducers'
import administrationApp from '../views/administration/reducers'
import globalDashboardApp from '../views/global-dashboard/reducers'
import authApp from '../views/login/reducers/index'
import mainApp from '../views/main/reducers'
import notificationApp from '../views/notifications/reducers'
import projectsApp from '../views/project/reducers'
import reportsApp from '../views/reports/reducers'
import userSettingsApp from '../views/settings/reducers'
import timeTrackingApp from '../views/time-tracking/reducers'
import { budgetReducer } from '../views/budget/reducers/budgetReducer'
import { budgetSettingsReducer } from '../views/budget/reducers/budgetSettingsReducer'
import { budgetDetailReducer } from '../views/budget/reducers/budgetDetailReducer'
import changeTrackerReducer from '../views/budget/slices/changeTrackerSlice'
import internalPositionsCategoryReducer from './budget/internalPositionsCategorySlice'
import externalCostsReducer from './budget/externalCostsSlice'
import suppliersReducer from './budget/suppliersSlice'
import clientsReducer from './budget/clientsSlice'
import templatesReducer from './budget/templatesSlice'
import budgetProjectReducer from './budget/budgetProjectSlice'
import { RootState } from './rootState'

const appReducer = combineReducers<RootState>({
  authState: authApp,
  administrationState: administrationApp,
  mainState: mainApp,
  projectsState: projectsApp,
  userSettingsState: userSettingsApp,
  timeTrackingState: timeTrackingApp,
  accountingState: accountingApp,
  globalDashboardState: globalDashboardApp,
  reportsState: reportsApp,
  notificationState: notificationApp,
  budget: budgetReducer,
  budgetSettings: budgetSettingsReducer,
  budgetDetail: budgetDetailReducer,
  budgetChangeTracker: changeTrackerReducer,
  budgetProject: budgetProjectReducer,
  internalPositionsCategory: internalPositionsCategoryReducer,
  externalCosts: externalCostsReducer,
  suppliers: suppliersReducer,
  clients: clientsReducer,
  templates: templatesReducer
})

const rootReducer = (state: RootState | undefined, action: AnyAction): CombinedState<RootState> => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === '[Auth] LOGOUT_SUCCESS') {
    state = {} as RootState;
  }

  return appReducer(state, action);
};

export default rootReducer;
